/* tslint:disable */

/**
 */
export class Logout {
    user_id: number;
    token: string;
}
